import { saveCurationForm } from 'api'
import { SubmitButton } from 'components/SubmitButton'
import { Field, Formik } from 'formik'
import { analyticsTracking } from 'lib/analytics/analytics'
import { useState } from 'react'
import { useToasts } from 'react-toast-notifications'
import styles from './modalMoreInfoForm.module.scss'

export const MoreInfoModalForm: React.FC<any> = ({ handleModalClose, dropId, handleComplete }) => {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false)
  const { addToast } = useToasts()

  let canSendData: boolean = true

  interface IFormMoreInfo {
    purpose: string
    distribution: string
    eligibility: string
    communityDetails: string
  }

  const curationFormQuestions: IFormMoreInfo = {
    purpose: 'What memory does this POAP capture?',
    distribution: 'How do you intend to distribute these POAPs to collectors?',
    eligibility: 'What is the criteria a collector must meet to receive your POAP?',
    communityDetails: 'Where can we learn more about your project, community or organization?',
  }

  const mapFormDataToEntry = (data: IFormMoreInfo, dropId: number) => {
    return {
      dropId: Number(dropId),
      questionData: Object.keys(curationFormQuestions).map((key) => {
        return {
          question: curationFormQuestions[key as keyof IFormMoreInfo],
          answer: data[key as keyof IFormMoreInfo] ?? '',
          fieldName: key,
        }
      }),
      type: 'curation_notes',
    }
  }

  const handleCreationModalSubmit = async (values: IFormMoreInfo) => {
    setIsSubmitting(true)

    if (canSendData) {
      canSendData = false

      // Complete form to send
      const formToSend = mapFormDataToEntry(values, dropId)

      try {
        await saveCurationForm(formToSend)
        analyticsTracking.drop.trackMoreInfoModalCompleteData()
        addToast('The info has been sent succesfully!', { appearance: 'success', autoDismiss: true })
      } catch (err) {
        addToast('Error to send info', { appearance: 'error', autoDismiss: true })
      }

      handleModalClose()
      handleComplete()
    }
  }

  return (
    <div className={styles.container}>
      <Formik
        initialValues={{
          purpose: '',
          distribution: '',
          eligibility: '',
          communityDetails: '',
        }}
        validateOnBlur={false}
        validateOnChange={false}
        onSubmit={handleCreationModalSubmit}
      >
        {({ handleSubmit }) => {
          return (
            <div className={'update-modal-container authentication_modal_container'}>
              <div className="select-container">
                <div className="bk-form-row">
                  <h3>Curation Review Supplemental Info</h3>

                  <label htmlFor="eventId">{curationFormQuestions.purpose}</label>
                  <Field type="string" name={'purpose'} placeholder={''} />

                  <label htmlFor="eventId">{curationFormQuestions.distribution}</label>
                  <Field type="string" name={'distribution'} placeholder={''} />

                  <label htmlFor="eventId">{curationFormQuestions.eligibility}</label>
                  <Field type="string" name={'eligibility'} placeholder={''} />

                  <label htmlFor="eventId">{curationFormQuestions.communityDetails} </label>
                  <Field type="string" name={'communityDetails'} placeholder={''} />
                </div>
              </div>
              <div className="modal-content">
                <div className="modal-buttons-container">
                  <SubmitButton text="Send Info" isSubmitting={isSubmitting} canSubmit={true} onClick={handleSubmit} />
                </div>
              </div>
            </div>
          )
        }}
      </Formik>
    </div>
  )
}
